export default function Contact() {
  return (
    <section id="contact" className="section">
      <div className="max-w-4xl mx-auto px-4">
        <div className="card-glass p-8">
          {/* Header row */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-6">
            {/* Logos: first on mobile (top), right on desktop */}
            <div className="order-1 md:order-2 self-center md:self-auto">
              <a
                href="#home"
                className="inline-flex items-center gap-3 mx-auto md:mx-0"
                aria-label="Axorclean"
              >
                <img
                  src="/logo.png"
                  alt="Axorclean"
                  className="h-20 w-auto select-none"
                  draggable="false"
                />
                <img
                  src="/axorcleanblack.png"
                  alt="Axorclean"
                  className="h-12 w-auto select-none"
                  draggable="false"
                />
              </a>
            </div>

            {/* Title + paragraph: second on mobile (under logos), left on desktop */}
            <div className="order-2 md:order-1 flex flex-col md:flex-row md:items-center md:gap-6">
              <h2 className="h2 md:mb-0 text-center md:text-left">Contact</h2>
              <p className="text-lg text-slate-700 md:mb-0 md:leading-snug max-w-2xl text-center md:text-left">
                Ai întrebări, sugestii sau dorești o ofertă personalizată?
                <br className="hidden md:block" />
                <strong className="block md:inline">
                  {" "}
                  Echipa Axor Clean
                </strong>{" "}
                este aici pentru tine!
              </p>
            </div>
          </div>

          {/* Contact grid */}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="h3 mb-2">Contactează-ne pentru orice întrebare:</h3>
              <ul className="space-y-2 text-slate-700">
                <li>
                  <span className="font-medium">Telefon:</span>{" "}
                  <a className="text-primary hover:underline" href="tel:+40775649806">
                    +40 775 649 806
                  </a>
                </li>
                <li>
                  <span className="font-medium">Email:</span>{" "}
                  <a className="text-primary hover:underline" href="mailto:office@axorclean.ro">
                    office@axorclean.ro
                  </a>
                </li>
                <li>
                  <span className="font-medium">Adresă:</span> Bazoșu Nou, Timiș
                </li>
              </ul>
            </div>

            <div>
              <h3 className="h3 mb-3">Social Media</h3>
              <div className="flex flex-wrap gap-3">
                {/* Facebook */}
                <a
                  href="https://www.facebook.com/people/Axor-clean-services/61576991432753/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full px-4 py-2 font-medium text-white shadow-lg hover:opacity-90 transition"
                  style={{ backgroundColor: "#1877F2" }}
                  aria-label="Deschide pagina de Facebook Axor Clean Services într-o filă nouă"
                  title="Facebook — Axor Clean Services"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M22 12.07C22 6.48 17.52 2 11.93 2S2 6.48 2 12.07c0 5.02 3.66 9.19 8.44 9.93v-7.02H7.9v-2.91h2.54V9.41c0-2.5 1.49-3.88 3.77-3.88 1.09 0 2.23.2 2.23.2v2.45h-1.26c-1.24 0-1.62.77-1.62 1.56v1.87h2.76l-.44 2.91h-2.32V22c4.78-.74 8.44-4.91 8.44-9.93z"
                    />
                  </svg>
                  <span>Facebook</span>
                </a>

                {/* Instagram */}
                <a
                  href="https://www.instagram.com/axor_clean_services/?igsh=Mzh4cDNhczh5ZnU%3D#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full px-4 py-2 font-medium text-white shadow-lg hover:opacity-90 transition"
                  style={{
                    background:
                      "linear-gradient(45deg,#F58529,#FEDA77,#DD2A7B,#8134AF,#515BD4)",
                  }}
                  aria-label="Deschide pagina de Instagram Axor Clean Services într-o filă nouă"
                  title="Instagram — Axor Clean Services"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="currentColor"
                      d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7m5 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10m0 2.2A2.8 2.8 0 1 0 14.8 12 2.8 2.8 0 0 0 12 9.2M17.25 6.75a1 1 0 1 1-1 1 1 1 0 0 1 1-1Z"
                    />
                  </svg>
                  <span>Instagram</span>
                </a>
              </div>

              <p className="text-slate-700 mt-3">
                Dă-ne un follow pentru noutăți, oferte și rezultate din teren.
              </p>
            </div>
          </div>

          <div className="mt-8">
            <a
              href="tel:+40775649806"
              className="inline-flex items-center gap-2 rounded-full bg-primary text-white px-6 py-3 font-semibold shadow-lg hover:opacity-90 transition"
            >
              Sună acum
            </a>
          </div>
        </div>

        {/* (Opțional) Banner imagine sub cardul de contact */}
        {/* <div className="mt-8">
          <img
            src="/contactb.jpg"
            alt="Axorclean — Contact și programări"
            loading="lazy"
            className="w-full h-52 md:h-72 lg:h-80 object-cover rounded-2xl shadow-lg"
          />
        </div> */}
      </div>
    </section>
  );
}
